import { useEffect } from 'react';
import { limpiarCrearSlice } from '../../redux/actions/actionsCrear';
import { RootState, useAppDispatch } from '../../redux/store';
import { useCookies } from 'react-cookie';
import { limpiarConsultaSlice } from '../../redux/actions/actionsConsulta';
import { buscarUsuarioPorCredenciales, buscarUsuarioPorId, guardarUsuarioEnRedux, limpiarAuthSlice } from '../../redux/actions/actionAuth';
import { useSelector } from 'react-redux';
import { USUARIO } from '@pcgerente-node/pcg-comun/dist/DTOs';

const UseAuth = () => {

  const dispatch = useAppDispatch()  
  
  const usuarioActual = useSelector((state: RootState) => state.auth.usuarioActual)

  const [cookies, setCookie, removeCookie] = useCookies(['idUsuario'])
  const idUsuarioLocalStorage = localStorage.getItem('idUsuario')
  

  useEffect(() => {
    if(!usuarioActual.autenticado){
      if(usuarioActual._ItemActivo?.id>0){
        dispatch(buscarUsuarioPorId(usuarioActual._ItemActivo.id))
      }else if(cookies.idUsuario && cookies.idUsuario>0){
        dispatch(buscarUsuarioPorId(cookies.idUsuario))
      }else if(idUsuarioLocalStorage){
        dispatch(buscarUsuarioPorId(JSON.parse(idUsuarioLocalStorage)))
      }else{
        logout() //si no se encontró de ninguna manera el id del usuario, lo obliga a logearse de nuevo 
      }
    }
  },[usuarioActual.autenticado])

  /**Arroja errores por si falla */
  const login = async (username: string, password: string) => {
      const usuarioEncontrado: USUARIO = await buscarUsuarioPorCredenciales(username, password)
      dispatch(guardarUsuarioEnRedux(usuarioEncontrado))
      setCookie('idUsuario', usuarioEncontrado.id, { path: '/', sameSite: 'strict', secure: true})      
  }

  // function cargarInfoRedux(idUsuario: number){
  //   dispatch(getAndSetMisDestinatarios(idUsuario));
  // }

  const logout = () => {
    removeCookie("idUsuario", { path: '/' });
    clearRedux()
  };

  function clearRedux(){
    dispatch(limpiarCrearSlice());
    dispatch(limpiarConsultaSlice("todos"))
    dispatch(limpiarAuthSlice())
  }

  return { login, logout};
};

export enum RolesUsuarios{
  CONDUCTOR= "CONDUCTOR",
  COMUN= "COMUN",
  /**No hace nada es solo un estado de referencia */
  INVITADO = "" 
}

export enum PERMISOS{
  PUEDE_LIQUIDAR_RUTA= "PUEDE LIQUIDAR RUTAS",
  GENERAL= "GENERAL"
}
export default UseAuth;
